/**
 * Updates an array by adding or removing an element identified by its unique identifier.
 *
 * @template I - Type of the unique identifier.
 * @template A - Type of the array elements.
 * 
 * @param {I} id - The unique identifier of the element to be added or removed.
 * @param {A[]} array - The array to be updated.
 * 
 * @returns {A[]} - The updated array after adding or removing the specified element.
 */
export const updateArrayById = <I, A>(id: I, array: A[]): A[] => {
    // Create a deep copy of the array to avoid modifying the original array.
    const updatedArray = JSON.parse(JSON.stringify(array));

    // Check if the element with the given id is already present in the array.
    if (updatedArray?.includes(id)) {
        // If present, remove the element from the array.
        updatedArray.splice(updatedArray.findIndex((sI: I) => id === sI), 1);
    } else {
        // If not present, add the element to the array.
        updatedArray.push(id);
    }

    // Return the updated array.
    return updatedArray;
};

export const areAllElementsInArrayXInArrayY = (x: (number | string)[], y: (number | string)[]) => {
    // Check if all elements in array x are in array y
    return x.every(elementX => y.includes(elementX));
}

export const areSomeElementsInArrayXInArrayY = (x: (number | string)[], y: (number | string)[]) => {
    // Check if some elements in array x are in array y
    return x.some(elementX => y.includes(elementX));
}

export const toTitleCase = (sentence: string): string => {
    const words = sentence?.split(" ");
    if (words) {
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        return words.join(" ");
    } else {
        return '';
    }
}